import { TagService } from 'src/services/tag/tag.service';
import { getTopLevelTag, getTopLevelTagByFullPath } from './getTopLevelTag';
import { isRoot } from './isRoot';
import { Summary, Tag } from 'src/services/tag/Tag';

export function getTagSummary<T extends Tag>(tag: T, tags: T[]): Summary {
  if (isRoot(tag.fullPath) && tag.summary) {
    return tag.summary;
  } else {
    const topLevelTag = getTopLevelTag(tag, tags);
    if (topLevelTag && topLevelTag.summary) {
      return topLevelTag.summary;
    } else {
      return TagService.DEFAULT_SUMMARY;
    }
  }
}
